import React from "react";
import "./../css/support.css";
import support from "../image/Image34.png";
import { useNavigate } from "react-router-dom";

export default function Support() {
  const navigate = useNavigate();
  const userdata = JSON.parse(localStorage.getItem("userData"));
  return (
    <div className="">
      <div className=" containers">
        <div className="d-flex row ">
          <div>
            <h5 className="texts">Help center</h5>
            <input
              className="helptext"
              name="companyname"
              placeholder="I have trouble with"
            />
          </div>
          <div className="ovals">
            <div>
              <img src={support} className="images" />
            </div>
          </div>
        </div>
      </div>
      <div className="supportreason">
        <label className="desc">Description</label>
        <textarea
          className="helpdescp"
          name="companyname"
          placeholder="Enter item description"
        />
      </div>
      <div className="text-end mt-5 me-3 suppsubmit">
        <button
          className="btn detail-btn me-2"
          onClick={() => {
            navigate(
              userdata?.role === "Owner"
                ? "/owner"
                : userdata?.role === "Contractor"
                ? "/contractor"
                : "/admin"
            );
          }}
        >
          Back
        </button>
        <button className="btn btn-cvault">Submit</button>
      </div>
    </div>
  );
}
